module.exports = __webpack_public_path__ + "static/media/TEMPTHEATERIMAGE.8794c788.jpg";